/*eslint no-unused-vars: "off"*/
import React from 'react';
import moment from 'moment-timezone';
import { Select, Modal } from 'antd';
import { formatToCurrency } from "../../../../Tools/formatToCurrency";
import chevronDown from '../../../../Assets/images/chevron-down.png';

const { Option } = Select;

const SERVICE_STATUS_COLOR_CLASS = {
  forecast: "gray-status",
  tentative: "info-status",
  scheduled: "blue-status",
  complete: "success-status",
  cancelled: "danger-status",
  incomplete: "warning-status"
};

const SERVICE_STATUS = {
  complete: 'COMPLETE',
  cancelled: 'CANCELED',
  incomplete: 'INCOMPLETE',
  forecast: 'FORECAST',
  scheduled: 'SCHEDULED'
};

class DataTable {
  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  //User List
  AllAccountList = (self) => {
    let { account_list_filter, is_change_log_payment } = self.state;
    const accountColumns = [
      {
        title: 'Invoice Date',
        dataIndex: 'invoice_date',
        key: 'uuid',
        render: (text, record) => (<span className="type ellipse">{moment(text).format('MM/DD/YYYY')}</span>)
      },
      {
        title: 'Invoice #',
        dataIndex: 'invoice_id',
        key: 'uuid',
        render: (text, record) => (<span className="type ellipse"># {text}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'franchise',
        key: 'uuid',
        render: (text, record) => (<span className="type ellipse">
          {
            record.user ? `${record.user.first_name} ${record.user.last_name}` : ''
          }

        </span>)
      },
      {
        title: 'Customer Type',
        dataIndex: 'service_order__service_type',
        key: 'service_order__service_type',
        render: (text, record) => (<span className="type ellipse text-capitalize">
          {
            record?.service_order?.service_type || ''
          }

        </span>)
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date',
        key: 'uuid',
        className: 'lfbdr',
        render: (text) => {
          return <span className="type ellipse">{this.UTCToLocal(text).format('MM/DD/YYYY')}</span>
        },
      },
      {
        title: 'Billing Type',
        dataIndex: 'billing_type',
        key: 'billing_type',
        sorter: true,
        showSorterTooltip: true,
        sortDirections: ['ascend', 'descend'],
        render: (text, record) => (<span className="type ellipse text-capitalize">{text}</span>)
      },
      {
        title: 'Sub Total',
        dataIndex: 'total',
        key: 'total',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(text)}</span>)
      },
      {
        title: 'Sales Tax',
        dataIndex: 'sales_tax',
        key: 'uuid',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(text)}</span>)
      },
      {
        title: 'Total',
        dataIndex: 'total_with_tax',
        key: 'total_with_tax',
        sorter: true,
        showSorterTooltip: true,
        sortDirections: ['ascend', 'descend'],
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(text)}</span>)
      },
      {
        title: 'Balance',
        dataIndex: 'balance_due',
        key: 'uuid',
        render: (text, record) => (record?.status==='draft'?<span className="type ellipse">--</span>:<span className="type ellipse">${formatToCurrency(text)}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'uuid',
        sorter: true,
        showSorterTooltip: true,
        sortDirections: ['ascend', 'descend'],
        // filterDropdown: (
        //   <div className="table_inner_filter_select">
        //     <ul>
        //       <li
        //         className={account_list_filter.status.includes('') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', '') }}
        //         id="">All statuses</li>
        //       <li
        //         className={account_list_filter.status.includes('open') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'open') }}
        //         id="open">Open</li>
        //       <li
        //         className={account_list_filter.status.includes('open-emailed') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'open-emailed') }}
        //         id="open-emailed">Open - Emailed</li>
        //       <li
        //         className={account_list_filter.status.includes('open-printed') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'open-printed') }}
        //         id="open-printed">Open - Printed</li>
        //       <li
        //         className={account_list_filter.status.includes('overdue') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'overdue') }}
        //         id="overdue">Overdue</li>
        //       <li
        //         className={account_list_filter.status.includes('void') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'void') }}
        //         id="void">Void </li>
        //       <li
        //         className={account_list_filter.status.includes('paid') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'paid') }}
        //         id="paid">Paid</li>
        //       <li
        //         className={account_list_filter.status.includes('draft') ? 'active' : ''}
        //         onClick={() => { self.StatusChange('status', 'draft') }}
        //         id="draft">Draft</li>
        //     </ul>
        //   </div>
        // ),
        render: (text, record) => (<span className="type ellipse text-successs text-capitalize">{text}</span>)
      },
      {
        title: 'Action',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => (
          <div
            style={{ opacity: '1' }}
            className="table_action_wrapper cursor_pointer" ref={node => { self.node = node; }}>
            {/* <span onClick={(e) => { e.stopPropagation(); self.ShowNav(record, text) }}><b>{self.state.curr_id === record.uuid ? self.state.set_table_active_action : ''} <i style={{ fontSize: '12px' }} className="las la-angle-down"></i></b></span> */}
            <Select
              className="simple_select"
              value={self.state.curr_id === record.uuid ? self.state.set_table_active_action : ''}
              onChange={(e) => {
                self.setState({
                  set_table_active_action: e,
                  curr_id: record.uuid
                })
                if (e === 'resend') {
                  self.setState({ loader: true })
                  self.props.resendInvoiceAPI(record.uuid);
                }
                else if (e === 'log_payment') {
                  self.setState({
                    crr_user: record,
                    is_log_payment: true
                  })
                  self.props.getCardList({ user__uuid: record?.user?.uuid });
                  self.props.getUserList({ limit: 10, offset: 0 });
                }
                else if (e === 'refund') {
                  self.setState({
                    crr_user: record,
                    showRefundPayment: true
                  })
                  self.props.getCardList({ user__uuid: record?.user?.uuid });
                }
                else if (e === 'delete') {
                  self.setState({
                    delete_visible: true,
                    delete_id: record.uuid
                  })
                }
                else if (e === 'void') {
                  self.setState({
                    loader: true
                  })
                  self.props.VoidInvoiceAPI(record.uuid);
                }

                else if (e === 'view_edit') {
                  self.props.ChangeComponent(5);
                  self.props.viewInvoice(record.uuid, record.service_order_uuid, record);
                }
                else if (e === 'print') {
                  self.props.printInvoice({ multiple_invoices_uuid: record.uuid, user_uuid: record?.user?.uuid });
                  self.setState({
                    loader: true
                  })
                }

                else if (e === 'payment_history') {
                  self.props.viewInvoice(record?.uuid)
                  self.props.selectedRecord(record)
                  self.props.ChangeComponent(6);
                }
              }}
            >
              <Option value="">Select</Option>
              <Option value="print">Print</Option>
              <Option value="view_edit">View/Edit</Option>
              <Option value="resend" disabled={record?.status === "draft"}>Resend</Option>
              <Option value="payment_history" disabled={record?.status === "draft"}>Payment History</Option>
              <Option value="log_payment" disabled={!is_change_log_payment || record?.status === "paid" || record?.status === "draft" || parseFloat(record?.balance_due)<=0}>Log Payment</Option>
              <Option value="refund" disabled={is_change_log_payment && record?.status !== "draft" ? false : true}>Refund Payment</Option>
              <Option value="delete" disabled={record?.status !== "draft"}>Delete</Option>
              <Option value="void">Void</Option>
            </Select>
            <Modal
              title="Delete Work Order"
              visible={self.state.delete_visible}
              onCancel={() => { self.setState({ delete_visible: false, delete_id: '' }) }}
              className="delete_user_modal"
              width={400}
              footer={[
                <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => self.setState({ delete_visible: false, delete_id: '' })}>No</button>,
                <button key="upload" className={`btn btn-waning`} onClick={() => self.deleteAccountInvoice()}>Yes</button>,
              ]}
            >
              <div>
                <p>Are You Sure! You want to delete selected Invoice! ?</p>
              </div>
            </Modal>
          </div>
        )
      },

    ]
    return accountColumns;
  }

  //Expired Card List
  AllExpiredCardList = (self) => {

    const ExpiredColumns = [
      {
        title: 'Acc Numbers',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => (<span className="type ellipse">{record?.user?.account_number}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'card_holder_name',
        key: 'card_holder_name',
        render: (text, record) => (<span className="type ellipse">{text}</span>)
      },

      {
        title: 'Franchise',
        dataIndex: 'franchise',
        key: 'franchise',
        className: 'lfbdr',
        render: (text, record) => (<span className="type ellipse">{record?.franchise?.name}</span>)
      },
      {
        title: 'Expiry Month',
        dataIndex: 'card_expiry_date',
        key: 'card_expiry_date',
        render: (text) => {
          return <span className="type ellipse">{text ? this.UTCToLocal(text).format('MMMM YYYY') : ''}</span>
        },
      },
      {
        title: 'Notified # / Last Reminder',
        dataIndex: 'email_reminder',
        key: 'email_reminder',
        render: (text, record) => {
          return record?.number_of_time_notified > 0 ? <b className="type ellipse">{`${record.number_of_time_notified} time${record.number_of_time_notified > 1 ? 's' : ''} / ${this.UTCToLocal(record.last_reminder).format('MMM DD YYYY')}`}</b> : <b>Never</b>
        }
      },
      {
        title: 'Account Balance',
        dataIndex: 'account_balance',
        key: 'account_balance',
        render: (text, record) => (<span className="type ellipse">${text ? formatToCurrency(text) : '0.00'}</span>)
      },
    ]
    return ExpiredColumns;
  }

  //Agging Summary Data
  AllAgginSummaryList = (self) => {
    const aggingColumns = [
      {
        title: 'Customer Name',
        dataIndex: 'user',
        key: 'user',
        render: (text, record) => (<span className="type ellipse">{text?.first_name} {text?.last_name}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => (<span className="type ellipse">{text ? <b className="danger">Suspended</b> : ''}</span>)
      },
      {
        title: 'Balance',
        dataIndex: 'invoices_balance',
        key: 'invoices_balance',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: 'Current',
        dataIndex: 'invoices_current',
        key: 'invoices_current',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: '1 - 30 days',
        dataIndex: 'invoices_one_thirty',
        key: 'invoices_one_thirty',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: '31 - 60 days',
        dataIndex: 'invoices_thirtyone_sixty',
        key: 'invoices_thirtyone_sixty',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: '61 - 90 days',
        dataIndex: 'invoices_sixtyone_ninty',
        key: 'invoices_sixtyone_ninty',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: '91+ Days',
        dataIndex: 'invoices_nintyone_plus',
        key: 'invoices_nintyone_plus',
        render: (text, record) => (<span className="type ellipse">{text ? `$${formatToCurrency(text)}` : '-'}</span>)
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => (
          <Select
            className="simple_select"
            onChange={(e) => {
              self.setState({
                set_table_active_action: e,
                curr_id: record?.user?.uuid,

              });
              if (e === "print") {
                self.setState({ loader: true });
                self.props.printInvoice({ multiple_invoices_uuid: record?.invoices?.join(','), user_uuid: record?.user?.uuid })
              }
              if (e === "suspend") {
                self.setState({ loader: true });
                self.props.suspendAccountAggingSummary({ suspend: 'True', user__uuid: record?.user?.uuid })
              }
              if (e === "unsuspend") {
                self.setState({ loader: true });
                self.props.suspendAccountAggingSummary({ suspend: 'False', user__uuid: record?.user?.uuid })
              }
            }}
            
            value={self.state.curr_id === record?.user?.uuid ? self.state.set_table_active_action : 'Select'}
          >
            <Option value="print">Print</Option>
            <Option value="suspend">Suspend</Option>
            <Option value="unsuspend">Unsuspend</Option>

          </Select>
        )
      }
    ];

    return aggingColumns;
  }

  //Payment History
  AllHistoryList = (self) => {
    const historyColumns = [
      {
        title: 'Invoice Number',
        dataIndex: 'invoice',
        key: 'invoice',
        render: (text, record) => (<span className="type ellipse">{record?.invoice_number || ''}</span>)
      },
      {
        title: 'Customer Name',
        dataIndex: 'user',
        key: 'user',
        render: (text, record) => (<span className="type ellipse">{record?.customer_name}</span>)
      },
      {
        title: 'Amount Received',
        dataIndex: 'amount_received',
        key: 'amount_received',
        render: (text, record) => (<b className="type ellipse">${record?.amount_received ? `${formatToCurrency(record?.amount_received)}` : '$ 0.00'}</b>)
      }
      ,
      {
        title: 'Payment Type',
        dataIndex: 'cash_payment',
        key: 'cash_payment',
        render: (text, record) => (<b className="type ellipse">{record?.payment_type?record?.payment_type==="cc" || record?.payment_type==="CC"?record?.payment_type.toUpperCase():record?.payment_type.charAt(0).toUpperCase() + record?.payment_type.slice(1):"-"}</b>)
      },
      {
        title: 'Check Id',
        dataIndex: 'cheque_id',
        key: 'cheque_id',
        render: (text, record) => (<b className="type ellipse">{record?.check_id !== 'None' ? record?.check_id : '-'}</b>)

      },
      {
        title: 'Received From',
        dataIndex: 'received_from',
        key: 'received_from',
        render: (text, record) => (<span className="type ellipse">{record?.received_from?record?.received_from:"-"}</span>)
      },
      {
        title: 'Received By',
        dataIndex: 'received_by',
        key: 'received_by',
        render: (text, record) => (<span className="type ellipse">{record?.received_by?record?.received_by:"-"}</span>)
      },
      {
        title: 'Payment Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (<span className="type ellipse">{record?.payment_date ? moment(record?.payment_date).format('MMM DD, YYYY') : 'Check'}</span>)
      },
      {
        title: 'Action',
        dataIndex: 'invoice',
        key: 'action',
        render: (text, record) => 
        {
          return( record?.allow_edit_delete && (record.payment_type !== "CC" && record.payment_type !== "CM") 
        && <div className="position-relative status-dropdown">
          <div className="flex ai-center">
            <span className="status-d-arrow">
              <img src={chevronDown} alt=""/>
            </span>
          </div>
          <ul className="status-dropdownmenu">
            <li>
              <a href="#" 
                onClick={(e) => { 
                  e.preventDefault();
                  self.setState({ show_edit_payment: true, selected_payment: record, edit:true })
                }}
              >Edit Payment
              </a>
            </li>
            <li>
              <a href="#" 
                onClick={(e) => { 
                  e.preventDefault();
                  self.setState({showDeleteModal: true, selected_payment: record});
                }}
              >Delete Payment
              </a>
            </li>
          </ul>
        </div>)
        }
      }
    ]
    return historyColumns;
  }

  // Accounting Work Orders Report data
  AllWorkOrdersList = (self) => {
    const workOrdersColumns = [
      {
        title: 'Work Order',
        dataIndex: 'work_order_number',
        key: 'work_order_number',
        // sorter: true,
        showSorterTooltip: false,
        defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a?.work_order_number?.localeCompare(b?.work_order_number),
        render: (text, record) => (
          <span className="type ellipse" style={{fontWeight: "bold", "color": "#1b8767"}}>
            {record?.work_order_number ? record?.work_order_number : "Not Created"}
          </span>)
      },
      {
        title: 'Customer',
        dataIndex: 'service_order__user__first_name',
        key: 'service_order__user__first_name',
        // sorter: true,
        showSorterTooltip: false,
        defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.user.localeCompare(b.user),
        render: (text, record) => (<span className="type ellipse">{record?.user}</span>)
      },
      {
        title: 'Customer Type',
        dataIndex: 'customer_type',
        key: 'customer_type',
        render: (text, record) => (
          <span className="type ellipse">{`${record?.customer_type.charAt(0).toUpperCase()}${record?.customer_type.slice(1)}`}</span>)
      },
      {
        title: 'Service Order',
        dataIndex: 'service_order__service_order_number',
        key: 'service_order__service_order_number',
        // sorter: true,
        defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.service_order.localeCompare(b.service_order),
        showSorterTooltip: false,
        render: (text, record) => (
          <span className="type ellipse" style={{fontWeight: "bold", "color": "#1b8767"}}>
            {record?.service_order}
          </span>)
      },
      {
        title: 'Service Date',
        dataIndex: 'scheduled_time',
        key: 'scheduled_time',
        // sorter: true,
        defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => a.service_date.localeCompare(b.service_date),
        showSorterTooltip: false,
        render: (text, record) => (<span className="type ellipse">{moment(record?.service_date).format('MMM DD, YYYY')}</span>)
      },
      {
        title: 'Billing Type',
        dataIndex: 'billing_type',
        key: 'billing_type',
        render: (text, record) => (<span className="type ellipse">{record?.billing_type}</span>)
      },
      {
        title: 'Amount Due',
        dataIndex: 'amount_due',
        key: 'amount_due',
        render: (text, record) => (<span className="type ellipse">${formatToCurrency(record?.amount_due)}</span>)
      },
      {
        title: 'Invoice Status',
        dataIndex: 'invoice_status',
        key: 'invoice_status',
        render: (text, record) => (<span className="type ellipse">{record.invoice_status}</span>)
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // sorter: true,
        showSorterTooltip: false,
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: (a, b) => {
          const a_status = a.status.replaceAll('_', ' ');
          const b_status = b.status.replaceAll('_', ' ');

          return a_status.localeCompare(b_status)},
        render: (text, record) => {
          switch(record?.status)
          {
          case 'cancelled_non_billable':
            return(
              <div className="status danger-status">
                  CANCELED
                <small>Non Billable</small>
              </div>
            )
          case 'cancelled_billable':
            return(
              <div className="status danger-status">
                  CANCELED
                <small>Billable</small>
              </div>
            )
          // case 'cancelled_billable':
          //   return(
          //     <div className="status danger-status">
          //         CANCELED
          //       <small>Billed</small>
          //     </div>
          //   )
          default:
            return <span className={record?.status ? `status ${SERVICE_STATUS_COLOR_CLASS[record.status]}`: ''}>
              {record?.status ? SERVICE_STATUS[record?.status]: ''}
            </span>
          }
        }
      },
      {
        title: '',
        dataIndex: 'record',
        key: 'record',
        className: 'no-wrap',
        render: (text, record) => self.renderAction(record)
      },
    ]
    return workOrdersColumns;
  }
}

export default new DataTable();